<template>
    <div class="setTime">
        <slider-bar
            :value="time"
            :min:="min"
            :max="max"
            :dotSize="30"
            color="#000"
            :formatter="formatter"
            @change="changeTimeValue"
        ></slider-bar>
    </div>
</template>

<script>
import SliderBar from '@/components/SliderBar.vue'

export default {
    components: {
        SliderBar
    },

    props: {
        min: {
            type: Number
        },
        max: {
            type: Number
        },
    },

    mounted() {
        this.setTime()
    },

    watch: {
        max() {
            this.time = [0, 0]
            this.setTime()
        }
    },

    data() {
        return{
            time: [0, 0]
        }
    },

    methods: {
        setTime () {
            this.time[0] = this.min
            this.time[1] = this.max
            // this.$emit('durationUpdate', this.time)
        },

        changeTimeValue(e) {
            this.time = e
            this.$emit('durationUpdate', this.time)
        },

        formatter (val) {

            if (val > 60) {
                let num = parseFloat(val / 60).toFixed(2).replace('.', ':')
                return this.translate('video_slider_min', num, `${num} min`)
            }
            return this.translate('video_slider_sec', val, `${val} sec`)
        },

        translate(key, num, msg) {
            if (typeof process.env.VUE_APP_IS_BACKEND !== 'undefined') {
                return msg
            }

            return this.$t(key, { num: num })
        }
    }
}
</script>

<style lang="scss">
.setTime {
    .vue-range-slider.slider-component .slider-tooltip-wrap.slider-tooltip-top {
        top: -6px !important;
    }
}
</style>
